import React, { useState, useEffect } from 'react';
import { getAgentUpdateStatus } from '../api';

// Persistent banner shown to an employee whose desktop agent is behind the
// latest published version. Stays until their reported version catches up
// (re-checked on mount / navigation). Dismiss only hides it for this version.
export default function AgentUpdateBanner({ onGoToDownloads }) {
  const [status, setStatus] = useState(null); // { latest, installed, update_available }
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    getAgentUpdateStatus().then(setStatus).catch(() => {});
  }, []);

  if (!status || !status.update_available) return null;
  // Allow dismissing per-version (re-appears when a newer version ships).
  if (dismissed === status.latest) return null;

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      background: 'linear-gradient(135deg, rgba(99,102,241,.14), rgba(6,182,212,.12))',
      border: '1px solid var(--glass-border)', borderRadius: 12,
      padding: '10px 16px', margin: '0 0 16px',
    }}>
      <span style={{ fontSize: '1.1rem' }}>⬆️</span>
      <div style={{ flex: 1, minWidth: 200 }}>
        <div style={{ fontWeight: 700, color: 'var(--text)', fontSize: '0.9rem' }}>
          A new version of the desktop app is available (v{status.latest})
        </div>
        <div style={{ color: 'var(--muted)', fontSize: '0.8rem' }}>
          You're on v{status.installed || '—'}. Please update to keep time tracking accurate.
        </div>
      </div>
      <button className="btn btn-primary" style={{ padding: '7px 16px', fontSize: '0.85rem' }}
        onClick={() => (onGoToDownloads ? onGoToDownloads() : null)}>
        Update now
      </button>
      <button onClick={() => setDismissed(status.latest)} aria-label="Dismiss"
        style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: '1.1rem', lineHeight: 1 }}>
        ×
      </button>
    </div>
  );
}
